/*
  Lichcards — leesbare labels in de collectiefilters.

  LET OP, en dit is de reden dat hier iets anders staat dan op de productpagina:
  een filterwaarde slaat op de HELE collectie, niet op één kaart. "Normal"
  betekent bij een SV-Rare holo, bij een oude common non-holo, bij Yu-Gi-Oh
  Unlimited en bij Magic non-foil. Er bestaat dus geen correcte vertaling naar
  "Holo" op filterniveau. Wat hier gebeurt is alleen het wegnemen van de
  misleidende term: "Normal" -> "Standaard". De werkelijke uitvoering staat op
  de productpagina (snippets/lichcards-finish.liquid).

  Er wordt uitsluitend gekeken naar echte facet-inputs (name begint met
  "filter.") en alleen naar waarden die in de tabel hieronder staan. Alles
  daarbuiten blijft onaangeraakt, en de value-attributen — waar het filteren
  zelf op draait — worden nooit gewijzigd.
*/
(function () {
  'use strict';

  var lang = (document.documentElement.getAttribute('lang') || 'nl')
    .slice(0, 2)
    .toLowerCase();

  var STANDARD = { en: 'Standard', de: 'Standard', fr: 'Standard', es: 'Estandar', it: 'Standard' }[lang] || 'Standaard';
  var SIGNED = { en: 'Signed', de: 'Signiert', fr: 'Signee', es: 'Firmada', it: 'Firmata' }[lang] || 'Gesigneerd';

  var MAP = {
    'Reverse-Holo': 'Reverse holo',
    'Reverse-Holo Normal': 'Reverse holo',
    'Reverse-Holo 1st-Edition': 'Reverse holo, 1st Edition',
    'Foil Normal': 'Foil',
    'Rainbow-Foil Normal': 'Rainbow foil',
    'Cold-Foil Normal': 'Cold foil',
    '1st-Edition': '1st Edition'
  };

  function labelFor(raw) {
    if (raw === 'Normal') return STANDARD;
    if (raw === 'Normal Signed') return STANDARD + ' - ' + SIGNED;
    return MAP[raw] || null;
  }

  /* Alleen de uitvoering-as: de Edition-optie en de tagfilters die dezelfde
     woorden gebruiken. Setnamen, condities en talen blijven met rust. */
  function isFinishFilter(input) {
    var n = (input.getAttribute('name') || '').toLowerCase();
    if (n.indexOf('option.edition') !== -1) return true;
    if (n.indexOf('option.editie') !== -1) return true;
    if (n.indexOf('filter.p.tag') === 0) return true;
    return false;
  }

  function sel(id) {
    return window.CSS && CSS.escape ? CSS.escape(id) : id;
  }

  /* Vervangt het tekstknooppunt dat exact de ruwe waarde is, zodat een
     aantalbadge zoals "(1.234)" ernaast blijft staan. */
  function swapText(el, raw, mapped) {
    if (!document.createTreeWalker) return false;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === raw) {
        node.nodeValue = node.nodeValue.replace(raw, mapped);
        return true;
      }
    }
    return false;
  }

  function apply() {
    var inputs = document.querySelectorAll('input[name^="filter."]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.getAttribute('data-lc-facet-done')) continue;
      if (!isFinishFilter(input)) continue;

      var raw = (input.value || '').trim();
      var mapped = labelFor(raw);
      if (!mapped) continue;

      var lab = null;
      if (input.id) lab = document.querySelector('label[for="' + sel(input.id) + '"]');
      if (!lab && input.closest) lab = input.closest('label');
      if (!lab) continue;

      if (swapText(lab, raw, mapped)) {
        lab.setAttribute('title', raw);
      }
      input.setAttribute('data-lc-facet-done', '1');
    }
  }

  function boot() {
    apply();
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
